import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {isEmpty} from "../../../components/commonmethod/CommonMethod";
import {PageHeader} from "../../../components/PageHeader";
import Th_title from "../../../components/Th_title";
import InputBasic from "../../../components/input/InputBasic";
import {skeleton} from "../../../redux/slice/apiSlice";
import {useDispatch} from "react-redux";
import {getNotice, updateNotice} from "../../../api/notice/NoticeService";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import TextAreaBasic from "../../../components/input/TextAreaBasic";
import {
    ContentDetailTwoColLayout,
    DetailFilePanel,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
    DetailSummaryListButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";
import "../fieldMng/shared/codeManageSettings.css";
import {SettingsContentHeroActions} from "../shared/SettingsContentHeroActions";

function NoticeUpdate() {
    const {id} = useParams();
    const dispatch = useDispatch();
    const [noticeData, setNoticeData] = useState({});
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!id) return;
        setNoticeData({});
        getNotice(id).then((response) => {
            setNoticeData(response.data);
        }).finally(
            dispatch(skeleton(false))
        );
    }, [id, dispatch]);

    const listUrl = `/settings/noticelist/${noticeData.gubun}`;

    const requireds = ["subject"];
    const update = async () => {
        if (requireds.some((e) => isEmpty(noticeData[e]))) {
            alert("필수값이 누락되었습니다.");
            return;
        }

        const response = await updateNotice(noticeData);
        if (response.status === 200) {
            alert("수정되었습니다.");
            navigate("/settings/notice/" + id, {
                state: {
                    test: location.state,
                },
            });
        }
    };

    const handleUpdate = () => {
        if (window.confirm("수정 완료합니다.")) {
            update();
        }
    };

    if (!noticeData?.id) {
        return null;
    }

    const headerActions = (
        <SettingsContentHeroActions>
            <DetailSummaryListButton url={listUrl}>취소</DetailSummaryListButton>
            <DetailSummaryButton onClick={handleUpdate}>수정</DetailSummaryButton>
        </SettingsContentHeroActions>
    );

    const mainPanel = (
        <DetailPanel title="기본정보">
            <DetailKvTable>
                <tbody>
                <tr>
                    <Th_title title="등록일시" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="createdAt"
                            data={{data: noticeData, setData: setNoticeData}}
                            value={noticeData.createdAt}
                        />
                    </Th_title>
                    <Th_title title="등록자" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="createdBy"
                            data={{data: noticeData, setData: setNoticeData}}
                            value={noticeData.createdBy}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="수정일시" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="updatedAt"
                            data={{data: noticeData, setData: setNoticeData}}
                            value={noticeData.updatedAt}
                        />
                    </Th_title>
                    <Th_title title="수정자" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="updatedBy"
                            data={{data: noticeData, setData: setNoticeData}}
                            value={noticeData.updatedBy}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="제목" colspan={3} className="fieldset-td" required={true}>
                        <InputBasic target="subject" data={{data: noticeData, setData: setNoticeData}}/>
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="내용" colspan={3} className="fieldset-td">
                        <TextAreaBasic target="content" data={{data: noticeData, setData: setNoticeData}}/>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const filePanel = (
        <DetailFilePanel
            title="파일"
            isEditing
            tableInfo={{tableName: "notice", joinKey: id}}
        />
    );

    return (
        <div className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout flex min-h-0 flex-1 flex-col code-manage-scope">
            {noticeData.gubun === "request"
                ? (
                    <PageHeader
                        header="요청공지사항"
                        indicator="서비스요청 > 요청공지사항 > 수정"
                        headerActions={headerActions}
                    />
                )
                : (
                    <PageHeader
                        header="공지사항관리"
                        indicator="환경설정 > 알람관리 > 공지사항관리 > 수정"
                        headerActions={headerActions}
                    />
                )}

            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailTwoColLayout main={mainPanel} aside={filePanel}/>
                </div>
            </DetailListPage>
        </div>
    );
}

export {NoticeUpdate};
